<app-dialog-header
  [title]="(data.integration ? 'Editar cadastro — ' : 'Novo cadastro — ') + providerName"
  [disabled]="busy" />
<form #registrationForm="ngForm" (ngSubmit)="save()" autocomplete="off">
  <p>Este cadastro pertence somente a este evento. Alterações aqui não modificam outros eventos.</p>
  @if (data.integration && !data.integration.event_id) {
    <p>Ao salvar, o cadastro antigo será copiado para este evento; o original será preservado.</p>
  }
  @if (error) {
    <p role="alert" class="error">{{ error }}</p>
  }
  <label
    >Nome do cadastro
    <input class="form-control" name="display_name" [(ngModel)]="name" required maxlength="100" [disabled]="busy" />
  </label>
  @if (data.provider === "google") {
    <label
      >Conversion ID
      <input
        class="form-control"
        name="conversion_id"
        [(ngModel)]="conversionId"
        required
        maxlength="128"
        placeholder="AW-…"
        [disabled]="busy" />
    </label>
    <label
      >Conversion label
      <input
        class="form-control"
        name="conversion_label"
        [(ngModel)]="conversionLabel"
        required
        maxlength="128"
        [disabled]="busy" />
    </label>
  } @else {
    <label
      >Pixel ID
      <input class="form-control" name="pixel_id" [(ngModel)]="pixelId" required maxlength="128" [disabled]="busy" />
    </label>
  }
  <p>
    O formato é verificado ao salvar; confira o recebimento na plataforma de anúncios. Um novo cadastro fica
    desabilitado até você habilitá-lo e configurar os envios deste evento.
  </p>
  <div class="actions">
    <app-button styleType="outlined" [disabled]="busy" (btnClick)="close()">Cancelar</app-button>
    <app-button type="submit" [disabled]="busy || !!registrationForm.invalid" [loading]="busy"
      >Salvar cadastro</app-button
    >
  </div>
</form>
